var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00005 5.20005C4.55822 5.20005 4.20005 5.55822 4.20005 6.00005V20C4.20005 20.4419 4.55822 20.8 5.00005 20.8H19C19.4419 20.8 19.8 20.4419 19.8 20V6.00005C19.8 5.55822 19.4419 5.20005 19 5.20005H5.00005ZM2.55005 6.00005C2.55005 4.23274 3.23274 3.55005 5.00005 3.55005H19C20.7674 3.55005 21.45 4.23274 21.45 6.00005V20C21.45 21.7674 20.7674 22.45 19 22.45H5.00005C3.23274 22.45 2.55005 21.7674 2.55005 20V6.00005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.125 1.5C16.7463 1.5 17.25 1.94072 17.25 2.48438V5.76562C17.25 6.30928 16.7463 6.75 16.125 6.75C15.5037 6.75 15 6.30928 15 5.76562V2.48438C15 1.94072 15.5037 1.5 16.125 1.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 1.5C8.49632 1.5 9 1.94072 9 2.48438V5.76562C9 6.30928 8.49632 6.75 7.875 6.75C7.25368 6.75 6.75 6.30928 6.75 5.76562V2.48438C6.75 1.94072 7.25368 1.5 7.875 1.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9.75C3 9.33579 3.47405 9 4.05882 9H19.9412C20.5259 9 21 9.33579 21 9.75C21 10.1642 20.5259 10.5 19.9412 10.5H4.05882C3.47405 10.5 3 10.1642 3 9.75Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.709555149a8195c67ef9d90cb9745fbb.svg";
export { ForwardRef as ReactComponent };